// extracted by mini-css-extract-plugin
export default {"dropdown":"MacrosPlus_dropdown__VYcHa"};